@if (this.timesheets.length>0) {
  <accordion style="margin:15px 0px;">
    @for (timesheet of timesheets; track timesheet) {
      <accordion-group >
        <div style="color: var(--navy-600);" accordion-heading><i style="color: var(--navy-500);"><b>{{timesheet.user}}</b></i>  {{timesheet.submitDate | date: 'dd/MM/yy HH:mm'}}</div>
        <app-timesheet-table [table]="timesheet.timesheet" [processId]="this.processId" [editable]="false" >
        </app-timesheet-table>
        @if (this.timesheet.status==='SUBMITTED' && (this.user?.roles.includes('CONTROLLER') || this.user?.roles.includes('CHEF') || this.user?.roles.includes('COORDINATOR') || this.user?.roles.includes('DIRECTOR_GENERAL') || this.user?.roles.includes('DIRECTOR_APPROVER'))) {
          <div class="row">
            <div class="col">
              <button class="btn btn-primary" style="float: right;"
              (click)="approveSheet(timesheet.timesheet.id)">Approve</button>
            </div>
          </div>
        }
      </accordion-group>
    }
  </accordion>
}
